export default __webpack_public_path__ + "static/media/residentialheader.756edf4d.jpg";